export default "__VITE_ASSET__CvdBaH0d__"